import {Entity, PrimaryGeneratedColumn} from "typeorm/browser";
import {Column} from "typeorm";

@Entity("municipio")
export class Municipio {
  @PrimaryGeneratedColumn("uuid")
  id?: string
  @Column({name: "nm_mun"})
  nome?: string
  @Column({name:"sigla_uf"})
  uf?: string

  get nomeCompleto(): string {
    if (this.nome == undefined) return ""
    return this.nome + " - " + this.uf
  }
}
